// @flow
import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import './E404.css';

export default (props: {}): React.DOM => (
  <div className="error-page">
    <Header noShadow/>
    <h1>This page doesn't exist</h1>
    <Footer/>
  </div>
);



// WEBPACK FOOTER //
// ./src/Errors/E404.js